export const tr = {
    'age-restriction-group-title': 'Yaş sınırı',
    'age-restriction-group-tooltip':
        'Yasalara göre bazı ürünlerin ve hizmetlerin reklamında (örneğin iletişim ürünleri ve çocuk gıdası) yaş sınırı kategorisi (+0, +6, +12, +16, +18) bulunmalıdır. {link}.',
    'age-restriction-title': 'Yaş',
    'background-color-title': 'Arkaplan rengi"',
    'border-color-title': 'Çerçeve rengi',
    'button-background-color-tooltip':
        'Metin, arkaplan ve yüklenen görselin renklerinde kolayca okunmalıdır. Renkler yeterince farklı olmalı. {link}.',
    'button-group-title': 'Buton',
    'button-group-tooltip':
        'Buton, site geçişine veya uygulamanın başlatılmasına uygun olmalıdır. Örneğin \\"daha fazla bilgi\\", \\"sipariş oluştur\\", \\"satın al\\". {link}.',
    'color-group-title': 'Renkler',
    'color-title': 'Metin rengi',
    'common-border-tooltip':
        'Çerçevenin rengi arkaplan rengiyle (ve yüklenen görselin renkleriyle) aynı olmamalıdır. {link}.',
    'content-title': 'Metin',
    'description-group-title': 'Ek metin',
    'disclaimer-group-title': 'Uyarı',
    'disclaimer-group-tooltip':
        'Yasalara göre bazı ürünlerin ve hizmetlerin reklamında (örneğin ilaçlar, finansal hizmetler, kooperatif inşaat projeleri) uyarı veya ek bilgi bulunmalıdır. {link}.',
    'disclaimer-title': 'Ülke',
    'domain-group-title': 'Alan adı',
    'fade-color-title': 'Renk',
    'fade-group-title': 'Ton',
    'fade-group-tooltip':
        'Fon, yüklenen görselin üzerine uygulanan yarı şeffaf bir katmandır. Bu sayede rengarenk veya desenli fondan dolayı ana metin ve diğer öğelerden dikkatinin alınmamasını sağlayabilirsiniz.',
    'headline-group-title': 'Ana metin',
    'icon-color-title': 'Simge rengi',
    'image-group-title': 'Görsel',
    'image-group-tooltip':
        'PNG ve JPEG formatında görsel veya maksimum 10 MB boyutunda animasyonsuz GIF dosyası yüklenebilir',
    'image-title': 'Dosya',
    'legal-group-title': 'Hukuki bilgiler',
    'legal-group-tooltip':
        'Yasalara göre bazı ürünlerin ve hizmetlerin reklamında (örneğin ilaçlar, finansal hizmetler, kooperatif inşaat projeleri) uyarı veya ek bilgi bulunmalıdırmalıdır. {link}.',
    'link-text': 'Daha fazla bilgi',
    'logo-group-title': 'Logo',
    'logo-title': 'Dosya',
    'special-group-title': 'Özel teklif'
};
